import { render, staticRenderFns } from "./MedicineNotification.vue?vue&type=template&id=30f65688"
import script from "./MedicineNotification.vue?vue&type=script&lang=js"
export * from "./MedicineNotification.vue?vue&type=script&lang=js"
import style0 from "./MedicineNotification.vue?vue&type=style&index=0&id=30f65688&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports